import { Container, Dialog, DialogContent, Slide, SlideProps, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";
import { WfAppBar, WfAppBarProps } from "@WahooFitness/redesignr";
interface Props {
  slideDirection: SlideProps["direction"];
  open: boolean;
  handleClose: () => void;
  headerProps?: WfAppBarProps;
  backgroundColor?: string;
  /**
   * Drops the shell's bottom safe-area padding on the dialog paper. Set it when the
   * content already pads its own bottom (e.g. a sticky WfActionGroup), otherwise the
   * two stack and lift the content twice.
   */
  edgeToEdge?: boolean;
}

const FullScreenDialog = ({
  children,
  slideDirection,
  open,
  handleClose,
  headerProps,
  backgroundColor,
  edgeToEdge,
}: PropsWithChildren<Props>) => {
  const { palette } = useTheme();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      slotProps={{
        paper: {
          className: edgeToEdge ? "wf-edge-to-edge" : undefined,
          sx: {
            background: palette.background.level1,
            "&.MuiPaper-root.MuiDialog-paper.MuiPaper-rounded": {
              borderRadius: 0,
            },
          },
        },
      }}
    >
      {headerProps && <WfAppBar {...headerProps} />}
      <Slide in={open} direction={slideDirection}>
        <DialogContent sx={{ padding: 0, width: "100%", margin: "auto", backgroundColor }}>
          <Container
            disableGutters
            sx={{
              height: "100%",
            }}
          >
            {children}
          </Container>
        </DialogContent>
      </Slide>
    </Dialog>
  );
};

export default FullScreenDialog;
